import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Music } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

const LINKS = [
  { label: 'Listen', to: '#listen' },
  { label: 'How it works', to: '#how' },
  { label: 'Marketing', to: '#marketing' },
  { label: 'FAQ', to: '#faq' },
  { label: 'Pricing', to: '/pricing' },
];

export default function Header() {
  const [solid, setSolid] = useState(false);
  const { theme, setTheme } = useTheme();
  const nav = useNavigate();

  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const go = (hash) => {
    if (!hash.startsWith('#')) { nav(hash); return; }
    const el = document.querySelector(hash);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    else nav(`/${hash}`);
  };

  return (
    <header className={`fixed top-0 inset-x-0 z-40 transition-all duration-500 ${solid ? 'bg-ink/85 backdrop-blur-xl border-b hairline' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-[76px] flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group">
          <span className="grid place-items-center w-11 h-11 rounded-full border hairline group-hover:border-gold/60 transition-colors">
            <Music size={18} className="text-gold" />
          </span>
          <span className="leading-none">
            <span className="font-display text-xl text-cream">Brand <span className="italic text-gold-grad">Melody</span></span>
            <span className="block eyebrow mt-1 text-[9px]">BY P. FRAZY</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-9">
          {LINKS.map((l) => (
            <button key={l.label} onClick={() => go(l.to)} className="text-sm text-cream/75 hover:text-cream transition-colors">{l.label}</button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <div className="hidden md:flex items-center p-1 rounded-full border hairline">
            {['artistic', 'luxury'].map((t) => (
              <button key={t} onClick={() => setTheme(t)}
                className={`px-3 py-1 rounded-full text-xs capitalize transition-colors ${theme === t ? 'bg-gold text-ink font-semibold' : 'text-cream/60 hover:text-cream'}`}>{t}</button>
            ))}
          </div>
          <button onClick={() => nav('/signin')} className="hidden sm:block text-sm text-cream/75 hover:text-cream transition-colors px-2">Sign in</button>
          <button onClick={() => nav('/start')} className="btn-gold rounded-full px-5 py-2.5 text-sm">Get your song</button>
        </div>
      </div>
    </header>
  );
}
